import React, { Component } from 'react';
import PortalMainRouter from '../router/portalMainRouter';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { grey500 } from 'material-ui/styles/colors';
import '../../services/ui/cssReferences';
import translationsStore from '../../stores/translationsStore';
import { observer } from 'mobx-react';

@observer
class MainPortalWrapper extends Component {

    render() {
        
        document.title = translationsStore.translate('CHECKMARX_ENTERPRISE');
        
        const muiTheme = getMuiTheme({
            palette: {
              textColor: grey500
            },
            appBar: {
              height: 50
            }
        });
        
        return(
            <div className='main-wrapper'>
                <div className='container-fluid'>
                    <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
                        <PortalMainRouter />

                    </MuiThemeProvider>
                </div>
            </div>
        );
    }
}

export default MainPortalWrapper;


// WEBPACK FOOTER //
// ./src/components/portal/mainPortalWrapper.jsx